<span class="badge" [ngClass]="cssClass">
  {{type}}
</span>
